import React, { useState, useMemo, useEffect } from "react"
import {
    Row,
    Col,
    Card,
    Table,
    Modal,
    Label,
    Form,
    CardBody,
    Input,
    DropdownMenu,
    Container,
    DropdownToggle,
    ModalBody,
    UncontrolledDropdown,
    Dropdown,
} from "reactstrap"
import {
    useTable,
    useSortBy,
    usePagination,
    useGlobalFilter,
} from "react-table"
// assets
import Loader from "pages/Separate/Loader"
import NewPagination from "components/Common/Newpagination"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import { fetchNodeData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import { customGlobalFilter, getInitials } from "utils/common-helpers"
import {
    allProjectsColumns,
    overAllWorkColumns,
} from "utils/columns/ElementsColumns/supportColumns"
import axios from "axios"
import configure from "configure"
import Select from "react-select"
import { DatePicker } from "antd"
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"
import { set } from "lodash"
import moment from "moment"

function TableContainer({ columns, data, allData, setData }) {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        state,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        gotoPage,
        setPageSize,
        pageOptions,
        setGlobalFilter,
        pageCount,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            globalFilter: customGlobalFilter,
            initialState: {
                sortBy: [
                    {
                        id: "id",
                        desc: true,
                    },
                ],
            },
        },

        useGlobalFilter,
        useSortBy,
        usePagination
    )
    const { pageIndex, pageSize, globalFilter } = state

    useEffect(() => {
        setPageSize(10)
    }, [])
    const [status, setStatus] = useState("0")

    return (
        <div>
            <div className="card-bodys ">
                <div className="position-relative table-responsive">
                    <Table className="table table-bordered mt-2" {...getTableProps()}>
                        <thead className={`fixed_view_payment_table`}>
                            {headerGroups.map((headerGroup, i) => (
                                <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column, index) => (
                                        <th
                                            key={index}
                                            className={`t-col-${index + 1} ${column.className}`}
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                        >
                                            <div className="d-flex align-items-center">
                                                <span className="flex-grow-1  header-text">
                                                    {column.render("Header")}
                                                </span>
                                                {column.isShortIcon && (
                                                    <span
                                                        onClick={() =>
                                                            column.getSortByToggleProps().onClick()
                                                        }
                                                        className="d-flex align-items-center ms-2"
                                                    >
                                                        <i
                                                            title="Ascending"
                                                            className={`bi bi-arrow-up info-icon ${column.isSorted && !column.isSortedDesc
                                                                ? "text-dark"
                                                                : ""
                                                                }`}
                                                        ></i>
                                                        <i
                                                            title="Descending"
                                                            className={`bi bi-arrow-down info-icon ${column.isSorted && column.isSortedDesc
                                                                ? "text-dark"
                                                                : ""
                                                                }`}
                                                        ></i>
                                                    </span>
                                                )}
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>

                        <tbody className="fix-table-body" {...getTableBodyProps()}>
                            {page.map((row, i) => {
                                prepareRow(row)
                                let status = ""
                                if (row?.original?.type == "activity") {
                                    if (
                                        row?.original?.status == "mark-completed" ||
                                        row?.original?.status == "complete"
                                    ) {
                                        status = true
                                    } else {
                                        status = false
                                    }
                                } else if (row?.original?.type == "project_task") {
                                    if (row?.original?.status != 0) {
                                        status = true
                                    } else {
                                        status = false
                                    }
                                }
                                const Timelog = row?.original?.total_actual_time == "0" || row?.original?.total_actual_time == undefined
                                return (
                                    <tr
                                        className={`row-hover ${Timelog ? 'bg-orange2' : ''} ${status ? "bg-green" : ""}`}
                                        {...row.getRowProps()}
                                        key={i}
                                    >
                                        {row.cells.map((cell, index) => {
                                            return (
                                                <td
                                                    key={index}
                                                    className={`t-col-${index + 1} ${cell.column.className
                                                        }`}
                                                    {...cell.getCellProps()}
                                                >
                                                    {cell.render("Cell")}
                                                </td>
                                            )
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    )
}

const OverallWork = () => {
    const [modal_Access, setAccessDenied] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [data, setData] = useState({})
    const [allData, setAllData] = useState({})
    const token = secureLocalStorage.getItem("auth_token")
    const [replyWidth, setReplyWidth] = useState(0)
    const [selectedRole, setSelectedRole] = useState(null)
    const [selectedProject, setSelectedProject] = useState(null)
    const [selectedMember, setSelectedMember] = useState([])
    const [roles, setRoles] = useState([])
    const [projects, setProjects] = useState([])
    const [members, setMembers] = useState([])
    const [inActiveMembers, setInActiveMembers] = useState([])
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const today = moment().format("DD-MM-YYYY")
    const [selectedDate, setSelectedDate] = useState(today)
    const [showWorkSummary, setShowWorkSummary] = useState(false)
    const [activeUsers, setActiveUsers] = useState([])
    const [totalOfficeHours, setTotalOfficeHours] = useState(0)
    const [presentOfficeHours, setPresentOfficeHours] = useState(0)
    const [totalOfficeLogs, setTotalOfficeLogs] = useState(0)
    const [totalTaskTime, setTotalTaskTime] = useState({})

    const toggleDropdown = () => setDropdownOpen(prev => !prev)

    const toggleLoading = loading => {
        setLoading(loading)
    }

    useEffect(() => {
        const updateWidth = () => {
            const viewportWidth = window.innerWidth
            setReplyWidth(viewportWidth * 0.98)
        }
        updateWidth()
        window.addEventListener("resize", updateWidth)
        return () => window.removeEventListener("resize", updateWidth)
    }, [])

    const getData = async () => {
        try {
            setLoading(true)
            const res = await axios.get(`${configure.nodeApi}/workLoad`)
            if (res?.data?.status) {
                setInActiveMembers(res.data.inactiveUsers)
                setTotalOfficeHours(res.data.metrics.total_office_hours || 0)
                setPresentOfficeHours(res.data.metrics.total_present_office_hours || 0)
                setTotalOfficeLogs(res.data.metrics.total_office_logs || 0)
                setTotalTaskTime(res.data.totalTaskTimeAllDates)

                setActiveUsers(res.data.activeUsers || [])
                setLoading(false)
                const fetchedData = res.data.data
                function mergeActivitiesIntoOthers(data) {
                    const mergedData = {}
                    mergedData["others"] = data["others"] ? [...data["others"]] : []

                    Object.entries(data).forEach(([projectId, entries]) => {
                        if (projectId === "others") return // Skip existing "others" key

                        entries.forEach(entry => {
                            const shouldGoToOthers = entry.project_name == null

                            if (shouldGoToOthers) {
                                mergedData["others"].push(entry)
                            } else {
                                if (!mergedData[projectId]) mergedData[projectId] = []
                                mergedData[projectId].push(entry)
                            }
                        })
                    })

                    return mergedData
                }
                setData(mergeActivitiesIntoOthers(res?.data.data))
                setAllData(res?.data.data)
                // Extract unique role, project, member
                const uniqueRoles = new Set()
                const uniqueProjects = new Set()
                const uniqueMembers = new Set()
                Object.values(fetchedData).forEach(entries => {
                    entries.forEach(entry => {
                        if (entry.role_name) uniqueRoles.add(entry.role_name)
                        uniqueProjects.add(entry.project_name || "Others")
                        const name =
                            entry.staff_name?.trim() ||
                            entry.alias_name?.trim() ||
                            entry.assignee?.trim()

                        if (name) uniqueMembers.add(name)
                    })
                })
                setRoles(Array.from(uniqueRoles))
                setProjects(Array.from(uniqueProjects))
                setMembers(Array.from(uniqueMembers)) // Remove "all"
            }
        } catch (error) {
            console.error("Error fetching workload data", error)
        }
    }

    function mergeActivitiesIntoOthers(data) {
        const mergedData = {}
        mergedData["others"] = data["others"] ? [...data["others"]] : []

        Object.entries(data).forEach(([projectId, entries]) => {
            if (projectId === "others") return

            entries.forEach(entry => {
                const shouldGoToOthers = entry.project_name == null

                if (shouldGoToOthers) {
                    mergedData["others"].push(entry)
                } else {
                    if (!mergedData[projectId]) mergedData[projectId] = []
                    mergedData[projectId].push(entry)
                }
            })
        })

        return mergedData
    }

    const getDataByDate = async selectedDate => {
        try {
            setLoading(true)
            const res = await axios.get(
                `${configure.nodeApi}/workLoad/${selectedDate}`
            )
            if (res?.data?.status) {
                setInActiveMembers(res.data.inactiveUsers)
                setTotalOfficeHours(res.data.metrics.total_office_hours || 0)
                setPresentOfficeHours(res.data.metrics.total_present_office_hours || 0)
                setTotalOfficeLogs(res.data.metrics.total_office_logs || 0)
                setActiveUsers(res.data.activeUsers || [])
                const fetchedData = res.data.data
                setLoading(false)


                setData(mergeActivitiesIntoOthers(fetchedData))
                setAllData(fetchedData)

                const uniqueRoles = new Set()
                const uniqueProjects = new Set()
                const uniqueMembers = new Set()
                Object.values(fetchedData).forEach(entries => {
                    entries.forEach(entry => {
                        if (entry.role_name) uniqueRoles.add(entry.role_name)
                        uniqueProjects.add(entry.project_name || "Others")
                        const name =
                            entry.staff_name?.trim() ||
                            entry.assignee?.trim() ||
                            entry.alias_name?.trim()

                        if (name) uniqueMembers.add(name)
                    })
                })

                setRoles(Array.from(uniqueRoles))
                setProjects(Array.from(uniqueProjects))
                setMembers(Array.from(uniqueMembers))
            }
        } catch (error) {
            console.error(
                `Error fetching workload data for date ${selectedDate}`,
                error
            )
        }
    }

    useEffect(() => {
        if (!Object.keys(data).length) {
            const today = moment().format("YYYY-MM-DD")
            setSelectedDate(today) // 👈 set initial date
            getDataByDate(today) // 👈 fetch data for today
        }
    }, [])

    const column1 = useMemo(() => overAllWorkColumns(), [])

    // Filtering by role, project, and member
    useEffect(() => {
        const filteredData = {}
        Object.entries(allData).forEach(([projectId, entries]) => {
            const filteredEntries = entries.filter(entry => {
                const roleMatch =
                    !selectedRole ||
                    selectedRole === "all" ||
                    entry.role_name === selectedRole

                const projectMatch =
                    !selectedProject ||
                    selectedProject === "all" ||
                    (entry.project_name || "Others") === selectedProject

                const name =
                    entry.staff_name?.trim() ||
                    entry.assignee?.trim() ||
                    entry.alias_name?.trim()

                const memberMatch =
                    selectedMember.length === 0 || (name && selectedMember.includes(name))

                return roleMatch && projectMatch && memberMatch
            })

            if (filteredEntries.length > 0) {
                filteredData[projectId] = filteredEntries
            }
        })

        setData(mergeActivitiesIntoOthers(filteredData))
    }, [selectedRole, selectedProject, selectedMember, allData])

    const uniqueMemberCount = useMemo(() => {
        const userSet = new Set()
        Object.values(data).forEach(entries => {
            entries.forEach(entry => {
                if (entry.user_id) {
                    userSet.add(entry.user_id)
                }
            })
        })
        return userSet.size
    }, [data])

    const colourStyles = {
        menuList: styles => ({
            ...styles,
            background: "white",
        }),
        menu: base => ({
            ...base,
            zIndex: 1200,
        }),
    }

    const roleOptions = roles.map(r => ({ label: r, value: r }))
    const projectOptions = projects.map(p => ({ label: p, value: p }))

    const options = members.map(m => ({
        label: m,
        value: m,
    }))

    const handleChange = selected => {
        if (!selected || selected.length === 0) {
            setSelectedMember([]) // Treat as all members
        } else {
            setSelectedMember(selected.map(opt => opt.value))
        }
    }

    // Convert selectedMember (array of values) to array of option objects
    const selectedOptions = options.filter(opt =>
        selectedMember.includes(opt.value)
    )

    const setDate = async e => {
        const selectedDate = e?.target?.value || null
        setSelectedDate(selectedDate)
        if (selectedDate) {
            getDataByDate(selectedDate)
        } else {
            getData()
        }
    }

    // const getTimeSummary = entries => {
    //   let totalEst = 0
    //   let totalActual = 0

    //   entries.forEach(entry => {
    //     // ✅ Handle both 'estimate_time' and 'estimation_time'
    //     const estimateStr = entry.estimate_time || entry.estimation_time || entry.est_hrs
    //     if (estimateStr) {
    //       const [h, m] = estimateStr.split(":").map(Number)
    //       totalEst += h * 60 + m
    //     }

    //     // ✅ Actual time from 'time_taken_minutes' or 'total_actual_time'
    //     const actualStr = entry.time_taken_minutes || entry.total_actual_time || entry.dev_hrs
    //     if (actualStr ) {
    //       totalActual += Number(entry.time_taken_minutes)
    //     } else if (entry.total_actual_time) {
    //       totalActual += Number(entry.total_actual_time)
    //     }
    //   })

    //   const formatTime = mins => {
    //     const hours = Math.floor(mins / 60)
    //     const minutes = mins % 60
    //     return `${hours.toString().padStart(2, "0")}:${minutes
    //       .toString()
    //       .padStart(2, "0")}`
    //   }

    //   return {
    //     estTimeFormatted: formatTime(totalEst),
    //     actTimeFormatted: formatTime(totalActual),
    //   }
    // }

    const getTimeSummary = entries => {
        let totalEst = 0
        let totalActual = 0

        const parseTimeToMinutes = str => {
            if (!str) return 0
            const [h, m] = str.split(":").map(Number)
            return (isNaN(h) ? 0 : h) * 60 + (isNaN(m) ? 0 : m)
        }

        entries.forEach(entry => {
            // Estimated time (check all keys)
            const estimateStr =
                entry.estimate_time || entry.estimation_time || entry.est_hrs
            totalEst += parseTimeToMinutes(estimateStr)

            // Actual time based on task type
            if (entry.type === "digital_task") {
                totalActual += parseTimeToMinutes(entry.dev_hrs)
            } else if (entry.time_taken_minutes != null) {
                totalActual += Number(entry.time_taken_minutes)
            } else if (entry.total_actual_time != null) {
                totalActual += Number(entry.total_actual_time)
            }
        })

        const formatTime = mins => {
            const hours = Math.floor(mins / 60)
            const minutes = mins % 60
            return `${hours.toString().padStart(2, "0")}:${minutes
                .toString()
                .padStart(2, "0")}`
        }

        return {
            estTimeFormatted: formatTime(totalEst),
            actTimeFormatted: formatTime(totalActual),
        }
    }
    return (
        <React.Fragment>
            {isLoading && <Loader />}
            <div>
                <Row>
                    <Col>
                        <Card>
                            <CardBody className="col-md-12">
                                <div
                                    className="d-flex justify-content-between align-items-center flex-wrap mb-3"
                                    style={{ gap: "0.5rem" }}
                                >
                                    {/* Title */}
                                    <div className="text-purple fs-5 fw-bold mb-0 d-flex align-items-center gap-2">
                                        Overall Today's Work
                                        <i
                                            className="bi bi-info-circle fill-purple"
                                            style={{ cursor: "pointer", fontSize: "18px" }}
                                            onClick={() => setShowWorkSummary(true)}
                                            title="Work Summary Info"
                                        />
                                    </div>

                                    {/* Filters */}
                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                        <div className="col-auto" style={{ maxWidth: "140px" }}>
                                            <input
                                                type="date"
                                                className="form-control"
                                                id="formrow-firstname-Input"
                                                value={selectedDate}
                                                onChange={setDate}
                                            />
                                        </div>

                                        {/* Member Filter */}
                                        <Select
                                            id="member-select"
                                            placeholder="Select Members"
                                            classNamePrefix="select"
                                            isMulti
                                            options={options}
                                            value={selectedOptions}
                                            onChange={handleChange}
                                            styles={{
                                                ...colourStyles,
                                                container: base => ({ ...base, width: 400 }),
                                            }}
                                        />

                                        {/* Role Filter */}
                                        <Select
                                            placeholder="Select Role"
                                            options={roleOptions}
                                            value={
                                                roleOptions.find(opt => opt.value === selectedRole) ||
                                                null
                                            }
                                            onChange={opt => setSelectedRole(opt ? opt.value : null)}
                                            isClearable
                                            classNamePrefix="select"
                                            styles={{
                                                ...colourStyles,
                                                container: base => ({ ...base, width: 250 }),
                                            }}
                                        />

                                        {/* Project Filter */}
                                        <Select
                                            placeholder="Select Project"
                                            options={projectOptions}
                                            value={
                                                projectOptions.find(
                                                    opt => opt.value === selectedProject
                                                ) || null
                                            }
                                            onChange={opt =>
                                                setSelectedProject(opt ? opt.value : null)
                                            }
                                            isClearable
                                            classNamePrefix="select"
                                            styles={{
                                                ...colourStyles,
                                                container: base => ({ ...base, width: 250 }),
                                            }}
                                        />

                                        {/* Inactive Count */}
                                        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                            <DropdownToggle
                                                tag="div"
                                                data-toggle="dropdown"
                                                className="rounded-circle d-flex justify-content-center align-items-center"
                                                style={{
                                                    width: "36px",
                                                    height: "36px",
                                                    border: "1px solid #6f42c1",
                                                    color: "purple",
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    cursor: "pointer",
                                                }}
                                                title="Inactive Members"
                                            >
                                                {inActiveMembers.length}
                                            </DropdownToggle>

                                            <DropdownMenu
                                                className="dropdown-menu-end p-2"
                                                style={{
                                                    minWidth: "200px",
                                                    maxHeight: "250px",
                                                    overflowY: "auto",
                                                    scrollbarWidth: 'thin'
                                                }}
                                            >
                                                {inActiveMembers.length > 0 ? (
                                                    inActiveMembers.map((user, index) => (
                                                        <div
                                                            key={index}
                                                            className="dropdown-item d-flex align-items-center"
                                                        >
                                                            {user.avatar ? (
                                                                <img
                                                                    src={`${configure.imgUrl}${user.avatar}`}
                                                                    alt={user.alias_name}
                                                                    className="rounded-circle me-2"
                                                                    style={{
                                                                        width: "30px",
                                                                        height: "30px",
                                                                        objectFit: "cover",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <div
                                                                    className="defualt-img me-2"
                                                                    title={user.alias_name}
                                                                >
                                                                    {getInitials(user.alias_name)}
                                                                </div>
                                                            )}

                                                            <span >{user.alias_name}</span>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div className="dropdown-item text-muted">
                                                        No inactive users
                                                    </div>
                                                )}
                                            </DropdownMenu>
                                        </Dropdown>
                                    </div>
                                </div>

                                {Object.entries(data).map(([projectId, entries], i) => {
                                    const { estTimeFormatted, actTimeFormatted } =
                                        getTimeSummary(entries)
                                    return (
                                        <div className="mb-4" key={projectId}>
                                            <div className="col-12 px-2 mb-2">
                                                <h5 className="mb-0 d-flex align-items-center">
                                                    <span>
                                                        {entries[0]?.project_name || "Others"}
                                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                                    </span>

                                                    <div className="d-flex gap-2 align-items-center">
                                                        {/* Est vs Act Time */}
                                                        <div className="px-2 py-1 rounded bg-light-purple text-purple small fw-semibold">
                                                            Est: {estTimeFormatted || "00:00"}
                                                        </div>

                                                        {/* Total Tasks */}
                                                        <div className="px-2 py-1 rounded bg-light-purple text-purple small fw-semibold">
                                                            Act: {actTimeFormatted}
                                                        </div>
                                                    </div>
                                                </h5>
                                            </div>
                                            <div className="responsive-table">
                                                <TableContainer
                                                    columns={column1}
                                                    data={entries}
                                                    toggleLoading={toggleLoading}
                                                    allData={allData}
                                                    setData={setData}
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                {showWorkSummary && (
                    <div className="note-sticky-form d-block">
                        <Draggable handle=".modal-header">
                            <ResizableBox
                                width={1100}
                                height={500}
                                style={{
                                    position: "fixed",
                                    top: "10%",
                                    right: "2%",
                                    zIndex: 1055,
                                    backgroundColor: "#fff",
                                }}
                            >
                                <div className="modal-header pe-4 mb-3">
                                    <h5 className="modal-title mt-0 text-purple">Work Summary</h5>
                                    <button
                                        className="s btn btn-red btn-label"
                                        onClick={() => setShowWorkSummary(false)}
                                    >
                                        <i className="dripicons-cross me-2 icon-center label-icon"></i>
                                        CANCEL
                                    </button>
                                </div>

                                <div
                                    className="p-3"
                                    style={{ maxHeight: "calc(100% - 56px)", overflow: "auto" }}
                                >
                                    {(() => {
                                        const seen = new Set()

                                        const userMap = Object.values(data)
                                            .flat()
                                            .reduce((acc, entry) => {
                                                const uid = entry.user_id || entry.assigned
                                                const taskKey = `${entry.task_id || entry.id}-${uid}`

                                                if (!acc[uid]) {
                                                    acc[uid] = {
                                                        id: uid,
                                                        avatar:
                                                            entry.avatar || entry?.assignee_avatar || entry?.staff_avatar || null,
                                                        alias_name: entry.alias_name || entry?.assignee || entry?.staff_name || "Unknown",
                                                        estTimeMinutes: 0,
                                                        actTimeMinutes: 0,
                                                        projects: new Set(),
                                                        tasks: new Set(), // NEW: Track unique tasks
                                                    }
                                                }

                                                // Estimated time
                                                const estParts = entry.estimation_time?.split(":") || [
                                                    "0",
                                                    "0",
                                                ]
                                                const estMins =
                                                    parseInt(estParts[0]) * 60 + parseInt(estParts[1])
                                                acc[uid].estTimeMinutes += isNaN(estMins) ? 0 : estMins

                                                // Actual time
                                                if (!seen.has(taskKey)) {
                                                    acc[uid].actTimeMinutes +=
                                                        parseInt(entry.total_actual_time) || 0
                                                    seen.add(taskKey)
                                                }

                                                // Unique projects
                                                if (entry.project_id) {
                                                    acc[uid].projects.add(entry.project_id)
                                                }

                                                // NEW: Unique tasks
                                                if (entry.task_id || entry.id) {
                                                    acc[uid].tasks.add(entry.task_id || entry.id)
                                                }

                                                return acc
                                            }, {})

                                        const users = Object.values(userMap)

                                        const formatTime = mins => {
                                            const h = String(Math.floor(mins / 60)).padStart(2, "0")
                                            const m = String(mins % 60).padStart(2, "0")
                                            return `${h}:${m}`
                                        }

                                        const totalEstTime = users.reduce(
                                            (sum, u) => sum + u.estTimeMinutes,
                                            0
                                        )
                                        const totalActTime = users.reduce(
                                            (sum, u) => sum + u.actTimeMinutes,
                                            0
                                        )
                                        return (
                                            <>
                                                {/* Top summary boxes */}
                                                <div
                                                    className="d-flex justify-content-between align-items-stretch flex-wrap gap-2 mb-3"
                                                    style={{ width: "100%" }}
                                                >
                                                    {[
                                                        {
                                                            label: "Total Office Hours",
                                                            value: totalOfficeHours,
                                                        },
                                                        {
                                                            label: "Present Office Hours",
                                                            value: presentOfficeHours,
                                                        },
                                                        {
                                                            label: "Total Office Logs",
                                                            value: totalOfficeLogs,
                                                        },
                                                        {
                                                            label: "Estimated Time",
                                                            value: formatTime(totalEstTime),
                                                        },
                                                        {
                                                            label: "Actual Time",
                                                            value: formatTime(totalActTime),
                                                        },
                                                    ].map((box, i) => (
                                                        <a key={i} className="text-purple pt-2 px-2 rounded work-status cr-status text-center" style={{ width: "18%" }}>
                                                            <h5> {box.label}</h5>
                                                            <h5>{box.value} </h5>
                                                        </a>
                                                    ))}
                                                </div>

                                                {/* Summary Table */}
                                                <div
                                                    className="table-responsive"
                                                    style={{ overflowY: "auto" }}
                                                >
                                                    <table className="table table-bordered text-center">
                                                        <thead className="bg-light-gray text-purple">
                                                            <tr>
                                                                <th>ID</th>
                                                                <th>Staff</th>
                                                                <th>Projects</th>
                                                                <th>Tasks</th> {/* NEW */}
                                                                <th>Est. Time</th>
                                                                <th>Act. Time</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {users.map((user, i) => (
                                                                <tr key={i}>
                                                                    <td>{user.id}</td>
                                                                    <td className="text-center d-flex justify-content-center">
                                                                        {user.avatar ? (
                                                                            <img
                                                                                src={`${configure.imgUrl}${user.avatar}`}
                                                                                alt={user.alias_name}
                                                                                title={user.alias_name}
                                                                                className="rounded-circle "
                                                                                style={{
                                                                                    width: "30px",
                                                                                    height: "30px",
                                                                                    objectFit: "cover",
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <div
                                                                                className="defualt-img "
                                                                                title={user.alias_name}
                                                                            >
                                                                                {getInitials(user.alias_name)}
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                    <td>{user.projects?.size || 0}</td>
                                                                    <td>{user.tasks?.size || 0}</td> {/* NEW */}
                                                                    <td>{formatTime(user.estTimeMinutes)}</td>
                                                                    <td>{formatTime(user.actTimeMinutes)}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        )
                                    })()}
                                </div>
                            </ResizableBox>
                        </Draggable>
                    </div>
                )}
            </div>
            <AccessDeniedPopup
                modal_Access={modal_Access}
                setAccessDenied={setAccessDenied}
            />
        </React.Fragment>
    )
}

export default OverallWork
